import { types } from "../../Actions/types";

const initialState = {
  mechanicsjointlist: [],
  error: null,
  mechanicsJointSingle: "",
  popupmodel: "",
};

const MechanicsJoint = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.MECHANICS_JOINT_LIST:
      return {
        ...state,
        mechanicsjointlist: payload,
        error,
      };
    case types.MECHANICS_JOINT_SINGLE:
      return {
        ...state,
        mechanicsJointSingle: payload,
        error,
      };
    case types.MECHANICS_JOINT_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default MechanicsJoint;
